export const bufferToBase64 = (buffer) => {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

export const bufferToBase64Url = (buffer) => {
    return bufferToBase64(buffer)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};

export const base64UrlToBuffer = (base64) => {
    const padLen = (4 - (base64.length % 4)) % 4;
    const base64Padded = base64 + '='.repeat(padLen);
    const binary = atob(base64Padded.replace(/-/g, '+').replace(/_/g, '/'));
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
};

export const preProcessOptions = (options) => {
    if (options.challenge) {
        options.challenge = base64UrlToBuffer(options.challenge);
    }
    if (options.allowCredentials) {
        options.allowCredentials = options.allowCredentials.map(c => {
            c.id = base64UrlToBuffer(c.id);
            return c;
        });
    }
    if (options.user && options.user.id) {
        options.user.id = base64UrlToBuffer(options.user.id);
    }
    if (options.excludeCredentials) {
        options.excludeCredentials = options.excludeCredentials.map(c => {
            c.id = base64UrlToBuffer(c.id);
            return c;
        });
    }
    return options;
};

export const postProcessCredential = (cred) => {
    const json = {
        id: cred.id,
        rawId: bufferToBase64Url(cred.rawId),
        type: cred.type,
        response: {
            clientDataJSON: bufferToBase64Url(cred.response.clientDataJSON),
        }
    };

    if (cred.response.attestationObject) {
        json.response.attestationObject = bufferToBase64Url(cred.response.attestationObject);
    }
    if (cred.response.authenticatorData) {
        json.response.authenticatorData = bufferToBase64Url(cred.response.authenticatorData);
    }
    if (cred.response.signature) {
        json.response.signature = bufferToBase64Url(cred.response.signature);
    }
    if (cred.response.userHandle) {
        json.response.userHandle = bufferToBase64Url(cred.response.userHandle);
    }

    return json;
};
